import { useQuery } from 'react-query';
import { DAY } from '../modules/audiences/components/SegmentTopics/customContextualTopicsUtils';
import { useGeoTargetingApi } from '../services/api/geoTargetingApi';

const defaultSelect = data =>
    data.map(region => {
        return { value: region.name, label: region.value };
    });
export const useCountryRegions = (countryCode, select = defaultSelect) => {
    const { getCountryRegions } = useGeoTargetingApi();

    const { data: regions, isLoading } = useQuery(['regions', countryCode], () => getCountryRegions(countryCode), {
        refetchOnWindowFocus: false,
        select,
        cacheTime: DAY,
        staleTime: DAY,
        enabled: !!countryCode,
    });

    return {
        isLoading,
        regions,
    };
};
